module.exports = __webpack_public_path__ + "img/Logo_VetrineOnline.com_ritagliato_trasparente.b0cbc91e.png";